import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle-indicacion-medica"
export default class extends Controller {
  static targets = ['checkbox']

  connect() {
  }

  toggle(e) {
    e.preventDefault();
    if (this.checkboxTarget.checked) {
      document.getElementById('farmaco-habitual').style.display = 'block';
      document.getElementById('farmaco-search').style.display = 'none';

      this.element.querySelector('[data-autocomplete-target="input"]').value = '';
      this.element.querySelector('[data-autocomplete-target="hidden"]').value = '';
    
    } else {
      document.getElementById('farmaco-habitual').style.display = 'none';
      document.getElementById('farmaco-search').style.display = 'block';
    }
  }
}
